import { ApiConfig, BackendConfig } from '@eng-ds/api-client';

const backendApi: ApiConfig[] = [
  {
    name: 'ACC_4',
    method: 'POST', // ACC_4
    url: '/apiNeta2DPortal/v1.0/ModificaPassword'
  },
  {
    name: 'ACC_5',
    method: 'POST', // ACC_5
    url: '/apiNeta2DPortal/v1.0/ResetPassword'
  },
  {
    name: 'ACC_5b',
    method: 'POST',
    url: '/apiNeta2DPortal/v1.0/CheckResetPassword'
  },
  {
    name: 'ACC_6',
    method: 'POST', // ACC_6
    url: '/apiNeta2DPortal/v1.0/ListaUdd'
  },
  {
    name: 'HOME_2',
    method: 'POST', // HOME_2
    url: '/apiNeta2DPortal/v1.0/NotificheAttive'
  },
  {
    name: 'HOME_3',
    method: 'POST', // HOME_3,
    url: '/apiNeta2DPortal/v1.0/NuoviFlussiCRM'
  },
  {
    name: 'HOME_3B',
    method: 'POST',
    url: '/apiNeta2DPortal/v1.0/NuoviFlussiCRMDServizi'
  },
  {
    name: 'HOME_4',
    method: 'POST', // HOME_4
    url: '/apiNeta2DPortal/v1.0/NuoviFileAnagrafica'
  },
  {
    name: 'HOME_6',
    method: 'POST', // HOME_6
    url: '/apiNeta2DPortal/v1.0/NuoviFileFatturazione'
  },
  {
    name: 'HOME_7',
    method: 'POST', // HOME_7
    url: '/apiNeta2DPortal/v1.0/DatiUtente'
  },
  {
    name: 'HOME_8',
    method: 'POST', // HOME_8
    url: '/apiNeta2DPortal/v1.0/Logout'
  },
  {
    name: 'FATT_1',
    method: 'POST', // FATT_1
    url: '/apiNeta2DPortal/v1.0/ElencoFatture'
  },
  {
    name: 'FATT_2',
    method: 'POST', // FATT_2
    url: '/apiNeta2DPortal/v1.0/FindGaranzieUdd'
  },
  {
    name: 'DOC_1',
    method: 'POST', // DOC_1
    url: '/apiNeta2DPortal/v1.0/DownloadFileDaDocumentale'
  },
  {
    name: 'ACCR_1',
    method: 'POST', // ACCR_1
    url: '/apiNeta2DPortal/v1.0/FindRemiVirtualeInfo'
  },
  {
    name: 'ACCR_2',
    timeout: 120000,
    method: 'POST', // ACCR_2
    url: '/apiNeta2DPortal/v1.0/ElencoRemiVirtualiAccreditate'
  },
  {
    name: 'RIC_1', // pagine inserimento puntuale e caricamento massivo
    method: 'POST', // RIC_1
    url: '/apiNeta2DPortal/v1.0/ListaTipiPrestazioneFlusso'
  },
  {
    name: 'RIC_2',
    method: 'POST', // RIC_2
    url: '/apiNeta2DPortal/v1.0/TemplatePaginaRichiestaSingola'
  },
  {
    name: 'RIC_3',
    method: 'POST', // RIC_3
    timeout: 120000,
    url: '/apiNeta2DPortal/v1.0/InserimentoRichiestaSingola'
  },
  {
    name: 'RIC_6',
    method: 'POST', // RIC_6
    url: '/apiNeta2DPortal/v1.0/ControlliValiditaRichiesta'
  },
  {
    name: 'RIC_7',
    method: 'POST', // RIC_7
    url: '/apiNeta2DPortal/v1.0/RichiestaElaborazione'
  },
  {
    name: 'RIC_7a',
    method: 'POST', // RIC_7a
    url: '/apiNeta2DPortal/v1.0/RicercaElaborazioniMassiva'
  },
  {
    name: 'RIC_7b',
    method: 'POST', // RIC_7b
    url: '/apiNeta2DPortal/v1.0/DownloadFileLog'
  },
  {
    name: 'RIC_9',
    method: 'POST', // RIC_9
    url: '/apiNeta2DPortal/v1.0/RicercaCaricamentoRichiesteMon'
  },
  {
    name: 'RIC_9b',
    method: 'POST', // RIC_9b
    url: '/apiNeta2DPortal/v1.0/RecuperaDatiFlusso'
  },
  {
    name: 'RIC_10',
    method: 'POST', // RIC_10
    url: '/apiNeta2DPortal/v1.0/DownloadFileRichiestaOriginale'
  },
  {
    name: 'RIC_11',
    method: 'POST', // RIC_11
    url: '/apiNeta2DPortal/v1.0/DownloadFlusso'
  },
  {
    name: 'RIC_12',
    method: 'POST', // RIC_12
    url: '/apiNeta2DPortal/v1.0/FindRichiesteMonitor'
  },
  {
    name: 'RIC_13',
    method: 'POST', // RIC_13
    url: '/apiNeta2DPortal/v1.0/FindStatiRichiesta'
  },
  {
    name: 'RIC_14',
    method: 'POST', // RIC_14
    url: '/apiNeta2DPortal/v1.0/CronologiaRichiesta'
  },
  {
    name: 'RIC_15',
    method: 'POST', // RIC_15
    url: '/apiNeta2DPortal/v1.0/ElencoFlussiRichiesta'
  },
  {
    name: 'RIC_16',
    timeout: 120000,
    method: 'POST', // RIC_16
    url: '/apiNeta2DPortal/v1.0/ElencoAllegatiRichiesta'
  },
  {
    name: 'RIC_17', // pagine monitor richieste e monitor caricamento richieste
    method: 'POST', // RIC_17
    url: '/apiNeta2DPortal/v1.0/ListaTipoPrestazione'
  },
  {
    name: 'RIC_17c',
    method: 'POST', // RIC_17c
    url: '/apiNeta2DPortal/v1.0/TipiPrestRicercaFlussiEsito'
  },
  {
    name: 'APP_1',
    method: 'POST', // APP_1
    url: '/apiNeta2DPortal/v1.0/RichiestaDisponibilitaAppuntamento'
  },
  {
    name: 'APP_2',
    method: 'POST', // APP_2
    url: '/apiNeta2DPortal/v1.0/ConfermaAppuntamento'
  },
  {
    name: 'APP_3',
    method: 'POST', // APP_3
    url: '/apiNeta2DPortal/v1.0/ModificaAppuntamento'
  },
  {
    name: 'APP_4',
    method: 'POST', // APP_4
    url: '/apiNeta2DPortal/v1.0/FindAppuntamenti'
  },
  {
    name: 'ANN_1',
    method: 'POST', // ANN_1
    url: '/apiNeta2DPortal/v1.0/RichiestaAnnullamento'
  },
  {
    name: 'FLUS_1',
    method: 'POST', // FLUS_1
    url: '/apiNeta2DPortal/v1.0/RicercaFlussi'
  },
  {
    name: 'getXLSX',
    method: 'POST', // FLUS_2
    url: '/apiNeta2DPortal/v1.0/EstrazioneExcelFlussi'
  },
  {
    name: 'getCSV',
    method: 'POST', // FLUS_3
    url: '/apiNeta2DPortal/v1.0/EstrazioneCSVFlussi'
  },
  {
    name: 'getXML',
    method: 'POST', // FLUS_4
    url: '/apiNeta2DPortal/v1.0/EstrazioneXMLFlussi'
  },
  {
    name: 'FLUS_5',
    method: 'POST', // FLUS_5
    url: '/apiNeta2DPortal/v1.0/DownloadFlussiAmmissibilita'
  },
  {
    name: 'downloadExcelFlussi',
    method: 'POST', // FLUS_2 replicata
    url: '/apiNeta2DPortal/v1.0/EstrazioneExcelFlussi'
  },
  {
    name: 'downloadCsvFlussi',
    method: 'POST', // FLUS_3 replicata
    url: '/apiNeta2DPortal/v1.0/EstrazioneCSVFlussi'
  },
  {
    name: 'downloadXMLFlussi',
    method: 'POST', // FLUS_4 replicata
    url: '/apiNeta2DPortal/v1.0/EstrazioneXMLFlussi'
  },
  {
    name: 'COM_1',
    method: 'POST', // COM_1
    url: '/apiNeta2DPortal/v1.0/RicercaComunicazioni'
  },
  {
    name: 'COM_4',
    method: 'POST', // COM_4
    url: '/apiNeta2DPortal/v1.0/DownloadAnagraficaPdR'
  },
  {
    name: 'ANAG_2',
    method: 'POST', // ANAG_2
    url: '/apiNeta2DPortal/v1.0/SchedulaAnagraficaPdr'
  },
  {
    name: 'PDR_1',
    timeout: 120000,
    method: 'POST', // PDR_1
    url: '/apiNeta2DPortal/v1.0/FindPdr'
  },
  {
    name: 'PDR_2',
    timeout: 120000,
    method: 'POST', // PDR_2
    url: '/apiNeta2DPortal/v1.0/RicercaIndirizzo'
  },
  {
    name: 'PDR_4',
    method: 'POST', // PDR_4
    url: '/apiNeta2DPortal/v1.0/FindListaComuni'
  },
  {
    name: 'PDR_5',
    method: 'POST', // PDR_5
    url: '/apiNeta2DPortal/v1.0/FindListaLocalita'
  },
  {
    name: 'PDR_6',
    method: 'POST', // PDR_6
    url: '/apiNeta2DPortal/v1.0/FindListaVie'
  },
  {
    name: 'PDR_7',
    method: 'POST', // PDR_7
    url: '/apiNeta2DPortal/v1.0/FindListaProvince'
  },
  {
    name: 'PDR_8',
    method: 'POST', // PDR_8
    url: '/apiNeta2DPortal/v1.0/StoricoFornitureDaPdr'
  },
  {
    name: 'PDR_9',
    method: 'POST', // PDR_9
    url: '/apiNeta2DPortal/v1.0/FindRichieste'
  },
  {
    name: 'PDR_10',
    method: 'POST', // PDR_10
    url: '/apiNeta2DPortal/v1.0/GetStoricoLetture'
  },
  {
    name: 'PDR_11',
    method: 'POST', // PDR_11
    url: '/apiNeta2DPortal/v1.0/GetAnagraficaPdr'
  },
  {
    name: 'AUTOL_1',
    method: 'POST', // AUTOL_1
    url: '/apiNeta2DPortal/v1.0/UploadAutoletture'
  },
  {
    name: 'AUTOL_3',
    method: 'POST', // AUTOL_3
    url: '/apiNeta2DPortal/v1.0/RicercaFileAutolettureCaricate'
  },
  {
    name: 'AUTOL_5',
    method: 'POST', // AUTOL_5
    url: '/apiNeta2DPortal/v1.0/DownloadAutoletture'
  },
  {
    name: 'getMenu',
    method: 'POST',
    url: '/apiNeta2DPortal/v1.0/LoadMenu'
  },
  {
    name: 'generateOTPAndQrCode',
    method: 'GET',
    url: '/oauth/GenerateOTPAndQrCode'
  },
  {
    name: 'setMFASecretKey',
    method: 'POST',
    url: '/oauth/SetMFASecretKey'
  },
  {
    name: 'logout',
    method: 'POST',
    url: '/oauth/logout'
  }
];

export const backendConfig: Partial<BackendConfig> = {
  timeout: 120000,
  api: backendApi,
  baseUrl: ''
};
